class DragHandle extends HTMLElement {
  static {
    let touchStartY = 0;
    let touchCurrentY = 0;
    let isTouching = false;
    const windowHeight = window.innerHeight;
    const closeThreshold = windowHeight * 0.5;

    // Add touch event listeners to handle touch-drag-to-close functionality
    document.addEventListener(
      'touchstart',
      (event) => {
        const dragHandle = event.target.closest('[draggable="true"]');
        if (!dragHandle) return;

        const parent = event.target.closest('[data-draggable-parent]');
        if (!parent || parent.ariaHidden === 'true') return;

        // Prevent default behavior when starting to drag
        event.preventDefault();

        touchStartY = event.touches[0].clientY;
        isTouching = true;

        parent.classList.add('dragging');

        let transfromTarget = parent;
        if (parent.tagName.toLowerCase() === 'drawer-element') {
          transfromTarget = parent.modalBody;
        }
        // Reset any existing transform
        transfromTarget.style.transition = 'none';
        transfromTarget.style.transform = 'translateY(0)';
      },
      { passive: false }
    );

    document.addEventListener(
      'touchmove',
      (event) => {
        if (!isTouching) return;

        const dragHandle = event.target.closest('[draggable="true"]');
        if (!dragHandle) return;

        touchCurrentY = event.touches[0].clientY;
        const deltaY = touchCurrentY - touchStartY;

        const parent = event.target.closest('[data-draggable-parent]');
        if (!parent) return;

        let transfromTarget = parent;
        if (parent.tagName.toLowerCase() === 'drawer-element') {
          transfromTarget = parent.modalBody;
        }

        // Prevent default scrolling behavior when dragging
        event.preventDefault();

        // Only allow downward drag
        if (deltaY > 0) {
          transfromTarget.style.transform = `translateY(${deltaY}px)`;

          if (deltaY > closeThreshold) {
            isTouching = false;
            parent.close();
            parent.classList.remove('dragging');
          }
        }
      },
      { passive: false }
    );

    document.addEventListener('touchend', (event) => {
      const parent = event.target.closest('[data-draggable-parent]');
      if (!parent || parent.ariaHidden === 'true') return;

      if (parent) {
        parent.classList.remove('dragging');

        let transfromTarget = parent;
        if (parent.tagName.toLowerCase() === 'drawer-element') {
          transfromTarget = parent.modalBody;
        }
        // Smoothly animate back to original position if not closed
        transfromTarget.style.transition = 'transform 0.3s ease-out';
        transfromTarget.style.transform = 'translateY(0)';
      }
      isTouching = false;
    });

    document.addEventListener('touchcancel', (event) => {
      const parent = event.target.closest('[data-draggable-parent]');
      if (parent) {
        parent.classList.remove('dragging');

        let transfromTarget = parent;
        if (parent.tagName.toLowerCase() === 'drawer-element') {
          transfromTarget = parent.modalBody;
        }
        // Reset position on cancel
        transfromTarget.style.transition = 'transform 0.3s ease-out';
        transfromTarget.style.transform = 'translateY(0)';
      }
      isTouching = false;
    });
  }
}

customElements.define('drag-element', DragHandle);

export { DragHandle };
